import { Controller } from 'stimulus';
import gsap from 'gsap';

class DetailHeader extends Controller {
  connect() {
    if (!this.hasPictureTarget) {
      return;
    }

    this.calculatePositions();

    this.pictureTimeline = gsap.timeline({
      paused: true,
    }).fromTo(this.pictureTarget, {
      scale: 1,
    }, {
      scale: this.pictureScaleFactor,
      duration: 0.2,
      ease: 'none',
    });

    this.handleScroll();
    this.reachedBottom = false;
  }

  calculatePositions() {
    const { scrollTop } = document.documentElement;

    this.pictureOffsetTop = this.pictureTarget.getBoundingClientRect().top + scrollTop;
    this.pictureStartWidth = this.pictureTarget.offsetWidth;
    this.pictureFinalWidth = this.pictureTarget.parentNode.offsetWidth;
    this.pictureScaleFactor = this.pictureFinalWidth / this.pictureStartWidth;
  }

  onWindowResize() {
    this.calculatePositions();
  }

  onWindowScroll() {
    this.handleScroll();
  }

  handleScroll() {
    if (typeof this.pictureTimeline === 'undefined') {
      return;
    }

    const scrollTop = window.scrollY;
    let progress = (scrollTop - this.pictureOffsetTop) / this.pictureOffsetTop;

    if (progress >= 1 && this.reachedBottom) {
      return;
    }

    if (progress < 1) {
      this.reachedBottom = false;
    } else if (progress > 1) {
      progress = 1;
      this.reachedBottom = true;
    }

    this.pictureTimeline.progress(progress).pause();
  }
}

DetailHeader.targets = [
  'picture',
];

export default DetailHeader;
